"use client";

import { GetAdStats } from "@/actions/details/GetAdStats";
import { HIDE_SCROLLBAR_STYLE } from "@/app/layout/LayoutConstants";
import AdDetailModel from "@/models/AdDetailModel";
import { Box, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { isbot } from "isbot";
import { FormatRelativeDate } from "@/actions/search/mappers/FormatRelativeDate";

export default function AdMeta({ ad }: { ad: AdDetailModel }) {
  const [adStats, setAdStats] = useState<{
    views: number;
    actions: number;
    saves: number;
    shares: number;
    enquiries: number;
  } | null>(null);

  useEffect(() => {
    (async () => {
      if (isbot(navigator.userAgent)) {
        return;
      }
      const stats = await GetAdStats(ad.id);
      setAdStats(stats);
    })();
  }, [ad.id]);

  return (
    <Box
      sx={(theme) => ({
        maxWidth: "100%",
        display: "flex",
        gap: 1,
        whiteSpace: "nowrap",
        overflow: "auto",
        color: "grey.600",
        alignItems: "center",
        ".MuiTypography-root": {
          ...theme.typography.body2,
        },
        ...HIDE_SCROLLBAR_STYLE,
      })}
    >
      {adStats ? (
        <>
          <Typography>
            {adStats.views} view{adStats.views !== 1 ? "s" : ""}
          </Typography>
          ·
          {adStats.actions > 0 && (
            <>
              <Tooltip
                title={
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                  >
                    <Typography>
                      {adStats.saves} save{adStats.saves !== 1 ? "s" : ""}
                    </Typography>
                    <Typography>
                      {adStats.shares} share{adStats.shares !== 1 ? "s" : ""}
                    </Typography>
                    <Typography>
                      {adStats.enquiries} enquir
                      {adStats.enquiries !== 1 ? "ies" : "y"} (message & phone)
                    </Typography>
                  </Box>
                }
              >
                <Typography>
                  {adStats.actions} action{adStats.actions !== 1 ? "s" : ""} ({adStats.saves}|{adStats.shares}|{adStats.enquiries})
                </Typography>
              </Tooltip>
              ·
            </>
          )}
          <Typography>{FormatRelativeDate("updated", ad.updatedAt)}</Typography>
          ·
          <Typography>{FormatRelativeDate("created", ad.createdAt)}</Typography>
        </>
      ) : (
        <Typography>&nbsp;</Typography>
      )}
    </Box>
  );
}
